import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import { useEffect } from "react";
import { Field, Form } from "react-final-form";
import { useQueryClient } from "react-query";
import ErreursConstante from "../../../_constantes/erreursConstantes.json";
import Libelle from "../../../_i18n/fr.json";
import Bouton from "../../../components/Button/Bouton";
import FormContainer from "../../../components/FormContainer";
import InputField from "../../../components/input/InputField";
import InputCalendrier from "../../../components/inputCalendrier/InputCalendrier";
import Snack from "../../../components/Snack";
import { MessageIn } from "../../../services/Api/swagger";
import { useMessages } from "./selectors";
import RenderError from "../../ErrorContainer";

interface MessagesFormErrors {
  titre?: string;
  contenu?: string;
  dateDebut?: string;
  dateFin?: string;
}

export interface MessagesFormData {
  titre: string;
  contenu: string;
  dateDebut: string;
  dateFin: string;
}

interface CustomProps {
  formErrors?: MessagesFormErrors;
  isFetching?: boolean;
  open: boolean;
  onClose: () => void;
  selectedId?: number;
  resetId: () => void;
}

function MessagesForm({ open, onClose, selectedId, resetId }: CustomProps) {
  const {
    isSuccessPostMessage,
    isFetchingPostMessage,
    handlePostMessage,
    errorPostMessage,
    resetPostMutation,
    isSuccessPutMessage,
    isFetchingPutMessage,
    handlePutMessage,
    errorPutMessage,
    resetPutMutation,
    getMessageById,
    onSubmit,
    message,
  } = useMessages(selectedId);

  const queriesClient = useQueryClient();

  const resetActions = () => {
    onClose();
    resetId();
  };
  useEffect(() => {
    if (isSuccessPostMessage || isSuccessPutMessage) {
      resetActions();
      queriesClient.invalidateQueries("messages");
    }
  }, [isSuccessPostMessage, isSuccessPutMessage]);

  // Efface le message d'erreur précédent à l'ouverture de la modale
  useEffect(() => {
    if (open) {
      resetPostMutation();
      resetPutMutation();
    }
  }, [open]);

  useEffect(() => {
    if (selectedId) {
      getMessageById(selectedId);
    }
  }, [selectedId]);

  console.log(errorPostMessage);
  return (
    <>
      {(isSuccessPostMessage || isSuccessPutMessage) && (
        <Snack
          open={isSuccessPostMessage || isSuccessPutMessage}
          variant="success"
          message="Votre message a bien été enregistré"
          onClose={() => {
            resetPostMutation();
            resetPutMutation();
          }}
        />
      )}
      <Dialog maxWidth="lg" open={open}>
        {!selectedId && (
          <DialogTitle
            id="create-message-dialog"
            fontWeight="700"
            fontSize="1.15rem"
          >
            {Libelle.pageMessages.ajouter.titre}
          </DialogTitle>
        )}
        {selectedId && (
          <DialogTitle
            id="create-message-dialog"
            fontWeight="700"
            fontSize="1.15rem"
          >
            {Libelle.pageMessages.modifier.titre}
          </DialogTitle>
        )}

        <DialogContent>
          <Form
            onSubmit={onSubmit}
            validate={validateForm}
            name="messagesForm"
            keepDirtyOnReinitialize={true}
            initialValues={selectedId && message}
          >
            {({ handleSubmit, pristine, submitting, form, values }) => (
              <form onSubmit={handleSubmit} noValidate>
                <FormContainer>
                  <Grid container spacing={1}>
                    <Grid
                      item
                      style={{ padding: 8 }}
                      minWidth="40%"
                      maxWidth="65%"
                    >
                      <Field
                        name="titre"
                        component={InputField}
                        label="Titre"
                        required
                        maxLength={50}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item style={{ padding: 8 }}>
                      <Field
                        name="dateDebut"
                        component={InputCalendrier}
                        label="Date de début"
                        minDate={Date.now()}
                        maxDate={Date}
                        required
                        variante="inline"
                        varianteInput="filled"
                      />
                    </Grid>
                    <Grid item style={{ padding: 8 }}>
                      <Field
                        name="dateFin"
                        component={InputCalendrier}
                        label="Date de fin"
                        minDate={Date.now()}
                        maxDate={Date}
                        required
                        variante="inline"
                        varianteInput="filled"
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid style={{ padding: 8 }} minWidth="65%" maxWidth="80%">
                      <Field
                        name="contenu"
                        component={InputField}
                        label="Contenu"
                        required
                        multiline
                        rows={4}
                        maxLength={500}
                      />
                    </Grid>
                  </Grid>
                </FormContainer>

                <DialogActions>
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    marginTop="8px"
                  >
                    <Grid item>
                      <Bouton
                        label="Annuler"
                        variant="contained"
                        color="secondary"
                        size="medium"
                        onClick={resetActions}
                      />
                    </Grid>
                    <Grid item>
                      <Bouton
                        fetching={isFetchingPostMessage}
                        label="Enregistrer"
                        variant="contained"
                        color="primary"
                        size="medium"
                        type="submit"
                      />
                    </Grid>
                  </Grid>
                </DialogActions>
                {errorPostMessage && (
                  <Alert onClose={resetPostMutation} severity="error">
                    {errorPostMessage.content.null || "Une erreur est survenue"}
                  </Alert>
                )}
                {errorPutMessage && (
                  <Alert onClose={resetPutMutation} severity="error">
                    {errorPutMessage.content.null || "Une erreur est survenue"}
                  </Alert>
                )}
              </form>
            )}
          </Form>
        </DialogContent>
      </Dialog>
    </>
  );
}

const validateForm = (
  values: MessagesFormData | MessageIn
): MessagesFormErrors => {
  const errors: MessagesFormErrors = {} as MessagesFormErrors;

  if (!values.titre) {
    errors.titre = ErreursConstante.formulaire.generale.champObligatoire;
  }
  if (!values.contenu) {
    errors.contenu = ErreursConstante.formulaire.generale.champObligatoire;
  }
  if (!values.dateDebut) {
    errors.dateDebut = ErreursConstante.formulaire.generale.champObligatoire;
  }
  if (!values.dateFin) {
    errors.dateFin = ErreursConstante.formulaire.generale.champObligatoire;
  }
  return errors;
};

export default MessagesForm;
